import { View, Pressable, Image, Dimensions } from "react-native";
import { FindifyTopBarOverlay } from "../genericPages/components/FindifyTopBarOverlay";
import React, { useContext, useEffect, useState } from "react";
import { PlaceColors } from "../genericPages/helpers/PlaceColors";
import { BasePage } from "../genericPages/helpers/BasePage";
import { useTranslation } from "react-i18next";
import { FindifySimpleHeader, SimpleHeaderAction } from "../genericPages/components/FindifySimpleHeader";
import { FindifyDataContext, FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { PlaceText } from "../genericPages/components/PlaceText";
import { BaseFindifyList } from "../genericPages/components/FindifyList";
import { getTranslatedString } from "../genericPages/helpers/FindifyTranslatedString";
import { PlaceListInitialUseEffect, PlaceListOnSelectedCategoryChangeEffect } from "@/layouts/genericPages/helpers/PlaceListHelper";
import { getContentIdForModule, getFeaturedImageUrl, makeContentDate, makeContentTitle } from "@/layouts/genericPages/helpers/DetailsHelpers";
import { DefaultShadow, TextShadow } from "../genericPages/helpers/DefaultShadows";


export const PlaceContentListTab = ({ navigation, ...props }: any) => {
    const [contents, setContents] = useState([]);
    const { t } = useTranslation();
    const [module, setModule] = useState('');
    const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
    const findifyDataContext = useContext(FindifyDataContext);
    const [loaded, setLoaded] = useState(false);
    const [availableModuleCategories, setAvailableModuleCategories] = useState<any[]>([]);
    const [actionsList, setActionsList] = useState<SimpleHeaderAction[]>([]);



    useEffect(() => {
        PlaceListInitialUseEffect({
            props,
            setContents,
            setLoaded,
            setModule,
            setSelectedCategories,
            findifyDataContext,
            setAvailableModuleCategories,
            contents,
            ignoreContentsWithoutCategory: true,
        });
    }, [])


    useEffect(() => {
        PlaceListOnSelectedCategoryChangeEffect({
            loaded,
            selectedCategories,
            setContents,
            module,
            findifyDataContext,
            setActionsList,
            availableModuleCategories,
            t,
        });
    }, [selectedCategories])

    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        {
            selectedCategories.length === 0 ?
                <MakeCategoriesList
                    t={t}
                    module={module}
                    navigation={navigation}
                    actionsList={actionsList}
                    findifyDataContext={findifyDataContext}
                    selectedCategories={selectedCategories}
                    setSelectedCategories={setSelectedCategories}
                    availableModuleCategories={availableModuleCategories}
                />
                :
                <MakeCategoryPage
                    t={t}
                    module={module}
                    contents={contents}
                    navigation={navigation}
                    actionsList={actionsList}
                    findifyDataContext={findifyDataContext}
                    selectedCategories={selectedCategories}
                    setSelectedCategories={setSelectedCategories}
                    availableModuleCategories={availableModuleCategories}
                />
        }
    </BasePage >;
};


const MakeCategoriesList = ({
    availableModuleCategories,
    findifyDataContext,
    navigation,
    module,
    selectedCategories,
    setSelectedCategories,
    t,
    actionsList,
}: {
    availableModuleCategories: any[],
    findifyDataContext: FindifyDataContextType,
    navigation: any,
    module: string,
    selectedCategories: number[],
    setSelectedCategories: Function,
    t: any,
    actionsList: SimpleHeaderAction[],
}) => {
    return <BaseFindifyList
        items={availableModuleCategories.map((category: any) => {
            return {
                ...category,
                id: category.content_id,
                image: getFeaturedImageUrl(category),
                title: getTranslatedString(category.name, findifyDataContext),
                resume: getTranslatedString(category.resume, findifyDataContext),
                date: makeContentDate(category, module),
                onPress: () => {
                    console.log('select me', category)
                    setSelectedCategories([category.category_id]);
                }
            };
        })}
        header={<FindifySimpleHeader navigation={navigation}
            title={
                selectedCategories.length === 1 ?
                    getTranslatedString(
                        availableModuleCategories.find((cat: any) => cat.category_id === selectedCategories[0])?.name, findifyDataContext) :
                    t('modules.content_types.' + module)
            }
            isEventLayout
            actions={actionsList}
        />}
        renderLine={(item, index) => {
            return MuseumListItemLine(null, item, index, module, findifyDataContext);
        }}
        enableGrid={false}
    />
}

const MakeCategoryPage = ({
    availableModuleCategories,
    contents,
    findifyDataContext,
    navigation,
    module,
    selectedCategories,
    setSelectedCategories,
    t,
    actionsList,
}: {
    availableModuleCategories: any[],
    contents: any[],
    findifyDataContext: FindifyDataContextType,
    navigation: any,
    module: string,
    selectedCategories: number[],
    setSelectedCategories: Function,
    t: any,
    actionsList: SimpleHeaderAction[],
}) => {
    const currentCat = availableModuleCategories.find((cat: any) => cat.category_id === selectedCategories[0]);
    return <BaseFindifyList
        items={contents.map((content: any) => {
            const contentId = getContentIdForModule(content, module);
            return {
                ...content,
                id: contentId,
                image: getFeaturedImageUrl(content),
                title: makeContentTitle(content, module, findifyDataContext),
                resume: getTranslatedString(content.resume, findifyDataContext),
                date: makeContentDate(content, module),
                onPress: () => {
                    navigation.push('PlaceContentDetails', {
                        module: module,
                        content_id: contentId,
                        page_slug: content.page_slug
                    });
                }
            }
        })}
        header={<>
            <FindifySimpleHeader navigation={navigation}
                isEventLayout
                title={getTranslatedString(currentCat?.name, findifyDataContext)}
                actions={actionsList}
            />
            <PlaceText
                style={{
                    padding: 10,
                    color: PlaceColors(findifyDataContext).primary.get(),
                }}
            >{getTranslatedString(currentCat?.description, findifyDataContext)}</PlaceText>
            <View style={{
                borderBottomWidth: 1,
                borderBottomColor: PlaceColors(findifyDataContext).primary.get(),
                marginHorizontal: 10
            }} ></View>
        </>}
        renderLine={(item, index) => {
            return MuseumListItemLine(currentCat, item, index, module, findifyDataContext, true);
        }}
        enableGrid={false}
    />
}
export const MuseumListItemLine = (category: any, item: any, index: number, module: string, findifyDataContext: FindifyDataContextType, isCategoryList?: boolean) => {
    const commonContainerStyles = {
        flex: 1,
        backgroundColor: PlaceColors(findifyDataContext).background.get(),
        borderRadius: 16,
        marginHorizontal: 15,
        marginVertical: 10,
        overflow: 'hidden',
        width: 'auto',
        ...DefaultShadow,
    };

    if (isCategoryList) {
        if (module == 'points_of_interest') {
            return <Pressable
                key={`news_index_${index}`}
                style={[{
                    backgroundColor: PlaceColors(findifyDataContext).background.get(),
                    marginHorizontal: 15,
                    marginVertical: 8,
                    padding: 15,
                    borderRadius: 16,
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 15,
                    alignItems: 'center',
                }, DefaultShadow]}
                onPress={item.onPress}
            >
                <Image
                    style={{ width: 90, height: 90, objectFit: 'cover', borderRadius: 12 }}
                    source={{ uri: item.image }}
                />
                <PlaceText
                    style={{
                        color: PlaceColors(findifyDataContext).primary.get(),
                        fontSize: 20,
                        fontWeight: '600',
                        flex: 1,
                    }}
                >
                    {getTranslatedString(item.title, findifyDataContext)}
                </PlaceText>
            </Pressable>
        }
        return <Pressable
            key={`news_index_${index}`}
            style={[{
                backgroundColor: PlaceColors(findifyDataContext).background.get(),
                marginHorizontal: 15,
                marginVertical: 8,
                padding: 15,
                borderRadius: 16,
                display: 'flex',
                flexDirection: 'row',
                gap: 15,
            }, DefaultShadow]}
            onPress={item.onPress}
        >
            <Image
                style={{ width: 90, height: 90, objectFit: 'cover', borderRadius: 12 }}
                source={{ uri: item.image }}
            />
            <View
                style={{
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}
            >
                <PlaceText
                    style={{
                        color: PlaceColors(findifyDataContext).text.get(),
                        fontSize: 16,
                        fontWeight: 'bold',
                    }}
                >
                    {getTranslatedString(item.title, findifyDataContext)}
                </PlaceText>
                {/* TODO VALIDATE IF CATEGORY SHOULD SHOW DATE */}
                {!(category?.hide_date_on_details) && <PlaceText
                    style={{
                        color: PlaceColors(findifyDataContext).text.withAlpha(200),
                        fontSize: 13,
                        marginTop: 2,
                    }}
                >
                    {makeContentDate(item, module)}
                </PlaceText>}
                <PlaceText
                    numberOfLines={2}
                    style={{
                        color: PlaceColors(findifyDataContext).text.withAlpha(160),
                        fontSize: 13,
                        marginTop: 6,
                    }}
                >
                    {getTranslatedString(item.resume, findifyDataContext)}
                </PlaceText>
            </View>
        </Pressable>
    }
    return (
        <Pressable
            key={`news_index_${index}`}
            style={{
                ...commonContainerStyles,
                aspectRatio: 1.7,
            }}
            onPress={item.onPress}
        >
            <Image
                style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover' }}
                source={{ uri: item.image }}
            />
            <View style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', height: '60%', backgroundColor: 'rgba(0,0,0,0.5)' }} />

            <View style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', padding: 20 }}>
                <PlaceText
                    style={[TextShadow, {
                        color: 'white',
                        fontSize: 22,
                        fontWeight: 'bold',
                    }]}
                >
                    {getTranslatedString(item.title, findifyDataContext)}
                </PlaceText>
            </View>
        </Pressable>
    );
}
